import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, state: String }
  static targets = ["message"]

  connect() {
    this.attempt = 0
    this.resume = () => {
      if (!document.hidden && navigator.onLine) {
        this.attempt = 0
        this.schedule(0)
      } else {
        this.cancel()
      }
    }
    document.addEventListener("visibilitychange", this.resume)
    window.addEventListener("online", this.resume)
    window.addEventListener("offline", this.resume)
    this.schedule(1000)
  }

  disconnect() {
    this.cancel()
    document.removeEventListener("visibilitychange", this.resume)
    window.removeEventListener("online", this.resume)
    window.removeEventListener("offline", this.resume)
  }

  cancel() {
    clearTimeout(this.timer)
    this.abort?.abort()
  }

  schedule(delay) {
    this.cancel()
    if (this.stateValue !== "pending" || document.hidden || !navigator.onLine || this.attempt >= 20) return
    this.timer = setTimeout(() => this.check(), delay)
  }

  async check() {
    this.abort = new AbortController()
    const signal = this.abort.signal
    this.attempt += 1
    try {
      const response = await fetch(this.urlValue, { credentials: "same-origin", cache: "no-store", signal,
        headers: { Accept: "application/json" } })
      if (response.status === 401 || response.status === 403 || response.redirected) return
      if (!response.ok) throw new Error("Setup status unavailable")
      if (!response.headers.get("content-type")?.includes("application/json")) return
      const status = await response.json()
      if (signal.aborted) return
      if (status.state === "ready" || status.state === "failed") {
        window.location.reload()
        return
      }
    } catch (error) {
      if (signal.aborted) return
      if (this.hasMessageTarget) this.messageTarget.textContent = "Waiting for a connection to finish setting up your sources."
    }
    this.schedule(Math.min(1000 * 2 ** Math.min(this.attempt, 4), 15000))
  }
}
